import {gql} from "@apollo/client";

export const FORECAST_START_DATE_CHANGE_STATUS = gql `
  subscription forecastStartDateChangeStatus {
    forecastStartDateChangeStatus
  }
`;
